import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { chatStore } from '~/lib/stores/chat';
import { themeStore } from '~/lib/stores/theme';
import { classNames } from '~/utils/classNames';
import styles from './LightRaysCloud.module.scss';

const ELLIPSE_CLASSES = [
  styles.EllipseOne,
  styles.EllipseTwo,
  styles.EllipseThree,
  styles.EllipseFour,
  styles.EllipseFive,
] as const;

export const LightRaysCloud = memo(({ className }: { className?: string }) => {
  const theme = useStore(themeStore);
  const chatStarted = useStore(chatStore.started);

  return (
    <div className={classNames(styles.RayContainer, className)} data-theme={theme} data-chat-started={chatStarted}>
      <div className={styles.BackgroundBlur} />
      <div className={styles.EllipsesContainer}>
        {ELLIPSE_CLASSES.map((ellipseClass, index) => (
          <div key={index} className={classNames(styles.Ellipse, ellipseClass)} />
        ))}
      </div>
    </div>
  );
});

LightRaysCloud.displayName = 'LightRaysCloud';
